import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import ResetPasswordStatusPage from './ResetPasswordStatusPage';

const _mapStateToProps = (state) => ({
    email: state.authentication.email,
});

export default withRouter(connect(_mapStateToProps)(ResetPasswordStatusPage));
